import { Component, Input } from '@angular/core';
import { CountryPipe } from 'src/app/pipe/country.pipe';

/**
 * `<app-submission-authors-display>` — linha inline READ-ONLY dos autores
 * ("Autores: Nome1 (SIGLA, País) [✉], Nome2 ..."). Passo 5 da migração
 * pra `<app-submission-export-view>`.
 *
 * Modo edição (drag-drop, remove, adicionar) permanece INLINE no paper-info
 * — usa `cdkDropList` + `FormGroup` + estado local. Aqui só renderizamos a
 * lista pronta.
 *
 * `formatAuthorAffiliation` é cópia LITERAL do método homônimo em
 * paper-info.ts:446 (comportamento idêntico — usa `acronym || name` +
 * país via `CountryPipe`, retorna '' quando não há dados).
 */
@Component({
  selector: 'app-submission-authors-display',
  templateUrl: './submission-authors-display.component.html',
  styleUrls: ['./submission-authors-display.component.scss'],
  providers: [CountryPipe],
})
export class SubmissionAuthorsDisplayComponent {
  /** Lista de autores. Cada item deve ter `user.{name,email,profile.{affiliation.{acronym,name},country}}`. */
  @Input() authors: any[] = [];
  /** `'chair'` faz os nomes virarem links pra `/admin/{eventId}/people/{userId}`.
   *  Outros valores renderizam nome como `<span>` simples. */
  @Input() viewerRole: 'author' | 'reviewer' | 'chair' | 'session-chair' = 'author';
  /** ID do evento — obrigatório quando `viewerRole === 'chair'` (compor o routerLink). */
  @Input() eventId: number | null = null;
  /** true = renderiza nome como texto puro mesmo em chair. Usado no export
   *  HTML (o documento é standalone, não faz sentido linkar pra rota do app). */
  @Input() disableUserLinks = false;

  constructor(private countryPipe: CountryPipe) {}

  /** Cópia LITERAL de `paper-info.ts:446` — mesma saída "(SIGLA, País)". */
  public formatAuthorAffiliation(author: any): string {
    const profile = author?.user?.profile;
    if (!profile) { return ''; }
    const acronym = profile.affiliation?.acronym || profile.affiliation?.name;
    const country = profile.country ? this.countryPipe.transform(profile.country) : '';
    const parts = [acronym, country].filter(v => !!v);
    return parts.length ? `(${parts.join(', ')})` : '';
  }

  public get isChair(): boolean { return this.viewerRole === 'chair' && !this.disableUserLinks; }
}
